module.exports = __webpack_public_path__ + "img/undraw_Add_files.ad70722b.svg";